import {
  Component,
  OnInit,
  NgZone,
  ViewChild,
  ElementRef,
  OnDestroy,
  ChangeDetectionStrategy
} from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { AuthenticationService } from "@layouts/login/authentication.service";
import { SharedService } from "@myproject/shared/shared.service";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "@myenv/environment";

import { CookieService } from "ngx-cookie-service";
import { enMessage } from "@shared/en-us-message";
import { configMessage } from "@shared/config-message";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { filter } from "rxjs/operators";
import { Subscription } from "rxjs";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HeaderComponent implements OnInit, OnDestroy {
  // localStorage = localStorage;
  // public tenantId = environment.tenantId;
  unoHeader = environment.unoHeader;
  public cmImageUrl = environment.cmImageUrl;
  public logoUrl!: string;
  public profilePicUrl!: string;
  public logoSafeUrl!: SafeUrl;
  public profilePicSafeUrl!: SafeUrl;
  currentUser: any = {};
  defaultReportUrl = localStorage;
  window = window;
  deviceId = "";
  url = "";
  accessRoleModules: any = {};
  permissionModules: any = [];
  notifications: any = [];
  dashboards: any = [];
  searchModel: any = {};
  userType!: string;
  accountKey!: string;
  responseMessage: any = {};
  impersonate: Boolean = false;
  isPermission = false;
  localImpersonate!: string;
  defaultAdminUrl!: string;
  defaultSupportAdminUrl!: string;
  defaultOrdersUrl!: string;
  @ViewChild("menuClose", { static: true }) menuClose!: ElementRef;
  alertMessage!: Boolean;
  unreadCount = 0;
  headerItems: any[] = [];
  outerHeader: any[] = [];
  dropdownHeader: any[] = [];
  randomNumber = Math.random();
  subTabHeader = false;
  menu_title = "";
  menu_subtitle = "";
  edgeimg = "../../../../assets/img/Edge_icon.svg";
  edgeToggle = false;
  profilePicRandomNumber: any = Math.random();
  productType!: String;
  isSupportUser: boolean = false;
  private routerSubscription!: Subscription;

  constructor(
    private _cookieService: CookieService,
    public translate: TranslateService,
    private authenticationService: AuthenticationService,
    private ngzone: NgZone,
    public router: Router,
    private sharedService: SharedService,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
  ) {
    authenticationService.changeEmitteds$.subscribe((data) => {
      if (data === null) {
        this.router.navigate(["/login"]);
      } else if (data !== null) {
        this.currentUser = data;
        this.getRoleAccessModule();
      }
    });
  }

  ngOnInit() {
    let currentUsr = JSON.parse(localStorage.getItem("currentUser") || '{}');
    this.productType = currentUsr.productType;
    this.url = this.router.url;
    this.currentUser = this.authenticationService.getCurrentUser();
    if (this.currentUser !== null) {
      this.getRoleAccessModule();
    }
    // edge icon change on reload only
    if (this.url.includes("devices")) {
      this.edgeToggle = true;
      this.edgeimg = "../../../../assets/img/Edge_icon_green.svg";
    }
    this.setMenuTitle();
    const data = localStorage.getItem("currentUser");
    const x = JSON.parse(data || '{}');
    this.userType = x.userType;
    this.accountKey = x.accountKey;
    this.logoUrl = `${environment.apiUrl}customers/logo?accountKey=${this.accountKey}`;
    this.profilePicUrl = `${environment.apiUrl}users/profile/picture?userId=${this.currentUser.userId}`;
    this.fetchImages();
    if (this._cookieService.get("user")) {
      this.impersonate = true;
    }
    const token = this.authenticationService.getHeaders();
    this.authenticationService.setHeaders(token);
    this.localImpersonate = localStorage.getItem("impersonate") || '';
    this.getUserNotification();
    this.getUnreadNotificationCount();

    // Subscribe to router events to handle route changes
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.url = event.url;
        this.setMenuTitle();
        if (event.url.includes("/support")) {
          localStorage.removeItem("supportViewMode");
          this.getRoleAccessModule();
        }
        if (
          (event.url.includes("/chargers") ||
            event.url.includes("/vehicles")) &&
          this.isSupportViewMode()
        ) {
          this.getRoleAccessModule();
        }
      });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  // Check if user is in support view mode
  isSupportViewMode(): boolean {
    return localStorage.getItem("supportViewMode") === "true";
  }

  getRoleAccessModule() {
    this.permissionModules = JSON.parse(
      localStorage.getItem("permissionModules") || '[]',
    );
    this.isSupportUser =
      this.permissionModules && this.permissionModules.includes("SUPPORT");
    this.getDefaultAdminUrl();
    this.setHeaderItems();
  }

  // on page reload only
  setMenuTitle() {
    const url = this.router.url.split("?")[0];
    const routeParam = url.split("/");
    let menu_title = "";
    let menu_subtitle = "";
    if (
      routeParam.includes("admin") &&
      (routeParam.includes("tags") ||
        routeParam.includes("device") ||
        routeParam.includes("groups"))
    ) {
      menu_title = "Edge";
      menu_subtitle = routeParam[2];
      this.subTabHeader = false;
      this.sharedService.setTitle(menu_title, menu_subtitle);
    } else if (routeParam.includes("admin")) {
      menu_title = "Admin";
      menu_subtitle =
        routeParam[2] === "developer" ? "Api Credentials" : routeParam[2];
      this.subTabHeader = false;
      this.sharedService.setTitle(menu_title, menu_subtitle);
    } else if (
      url.includes("data") ||
      url.includes("data-simulator") ||
      url.includes("destinations") ||
      url.includes("trips") ||
      url.includes("location-history") ||
      url.includes("location-history?searchBy=&value=")
    ) {
      menu_title = "Data";
      this.subTabHeader = true;
      menu_subtitle =
        routeParam[2] === "data-schemes"
          ? "Data Schemes"
          : routeParam[1] === "destinations"
            ? "Destinations"
            : routeParam[1] === "data"
              ? "Messages"
              : routeParam[1] === "data-simulator"
                ? "Data Simulator"
                : routeParam[1];
      this.sharedService.setTitle(menu_title, menu_subtitle);
    } else if (routeParam.includes("reports")) {
      menu_title = "Reports";
      menu_subtitle = "General";
      this.subTabHeader = false;
      this.sharedService.setTitle(menu_title, menu_subtitle);
    } else {
      this.subTabHeader = false;
      this.sharedService.setTitle("", "");
    }
  }
  changeEdgeIcon() {
    if (this.edgeToggle) {
      this.edgeToggle = false;
      this.edgeimg = "../../../../assets/img/Edge_icon.svg";
    } else {
      this.edgeToggle = true;
      this.edgeimg = "../../../../assets/img/Edge_icon_green.svg";
    }
  }
  // on click of nav bar button
  subNavHeader(p1: string) {
    if (p1 === "DATAHUB") {
      this.subTabHeader = true;
    } else {
      this.subTabHeader = false;
    }
  }

  setHeaderItems() {
    // Clear existing header items before rebuilding
    this.headerItems = [];
    this.outerHeader = [];
    this.dropdownHeader = [];

    let header = [];
    header = this.unoHeader
      ? configMessage.unoHeaderItems
      : configMessage.headerItems;
    const isImpersonate =
      !!this._cookieService.get("user") ||
      localStorage.getItem("impersonate") === "true";
    const isEvseOrVim =
      this.productType === "EVSE" || this.productType === "VIM";
    header.map((item: any) => {
      if (
        item === "DASHBOARD-HOME" &&
        this.permissionModules.includes("SUPPORT-DASHBOARD")
      ) {
        const shouldShowDashboard =
          this.isSupportViewMode() || !this.isSupportUser;
        if (shouldShowDashboard) {
          const obj: any = {};
          obj.name = "Dashboard";
          obj.permission = "DASHBOARD";
          obj.icon = configMessage.headerIcons["DASHBOARD"];
          obj.route = "/dashboard";
          this.headerItems.push(obj);
        }
      }
      if (item === "DEVICE" && this.permissionModules.includes("DEVICE")) {
        if (isEvseOrVim) {
          this.headerItems.push({
            name: "menu.DEVICE",
            permission: "DEVICE",
            icon: configMessage.headerIcons["DEVICE"],
            route: "/v2/devices",
          });
        } else if (this.productType === "BITBREW") {
          this.headerItems.push({
            name: "menu.DEVICE",
            permission: "DEVICE",
            icon: configMessage.headerIcons["DEVICE"],
            route: "/devices",
          });
        }
        return;
      }
      if (
        item === "OTA" &&
        (this.permissionModules.includes("OTA") ||
          this.permissionModules.includes("OTA-PARTNER"))
      ) {
        if (isEvseOrVim) {
          this.headerItems.push({
            name: "menu.OTA",
            permission: "OTA",
            icon: configMessage.headerIcons["OTA"],
            route: "/v2/ota",
          });
        } else if (this.productType === "BITBREW") {
          this.headerItems.push({
            name: "menu.OTA",
            permission: "OTA",
            icon: configMessage.headerIcons["OTA"],
            route: "/ota",
          });
        }
        // Data Hub is exclusive to OTA-PARTNER accounts
        if (this.sharedService.isOtaPartner()) {
          this.headerItems.push({
            name: "Data Hub",
            permission: "DESTINATIONS",
            icon: "database",
            route: "/destinations",
          });
        }
        return;
      }
      if (item === "OVERVIEW") {
        if (!this.permissionModules.includes("SUPPORT")) {
          return;
        }
        if (this.isSupportUser && this.isSupportViewMode()) {
          return;
        }
        this.headerItems.push({
          name: "Overview",
          permission: "OVERVIEW",
          icon: configMessage.headerIcons["OVERVIEW"],
          route: "/overview",
        });
        return;
      }
      if (
        this.permissionModules.includes(item) &&
        item !== "DEVICE" &&
        item !== "DASHBOARD" &&
        item !== "OTA"
      ) {
        if (isImpersonate && item === "ADMIN") {
          return;
        }
        // Hide Admin for OTA and OTA-PARTNER even if ADMIN permission is present
        if (item === "ADMIN" && this.sharedService.hasOtaAccess()) {
          return;
        }
        // Hide SUPPORT tab if user is a support user and in view mode
        if (
          item === "SUPPORT" &&
          this.isSupportUser &&
          this.isSupportViewMode()
        ) {
          return;
        }
        const obj: any = {};
        obj.name = `menu.${item}`;
        obj.permission = item;
        obj.icon = configMessage.headerIcons[item];
        if (item === "ADMIN") {
          obj.route =
            localStorage.getItem("defaultAdminUrl") || "/admin/users";
        } else {
          obj.route = configMessage.route[item];
        }
        this.headerItems.push(obj);
      }
    });
    // Add unified Home tab for Chargers/Vehicles
    if (this.permissionModules.includes("SUPPORT-DASHBOARD")) {
      const shouldShowHome = this.isSupportViewMode() || !this.isSupportUser;
      if (shouldShowHome) {
        const homeItemExists = this.headerItems.some(
          (h) => h.permission === "HOME",
        );
        if (!homeItemExists) {
          this.headerItems.unshift({
            name: "Home",
            permission: "HOME",
            icon: "home",
            route: "/chargers",
          });
        }
      }
    }
    const sortedHeaderItems = this.sortHeaders(this.headerItems);
    if (sortedHeaderItems.length >= 5) {
      for (let i = 0; i < sortedHeaderItems.length; i++) {
        if (i >= 8) {
          this.dropdownHeader.push(sortedHeaderItems[i]);
        } else {
          this.outerHeader.push(sortedHeaderItems[i]);
        }
      }
    } else {
      this.outerHeader = sortedHeaderItems;
    }
  }

  sortHeaders(data: any[]) {
    const rank: Record<string, number> = {
      HOME: 0,
      DASHBOARD: 1,
      DEVICE: 2,
      OTA: 3,
      DESTINATIONS: 4,
      ADMIN: 5,
      OVERVIEW: 5.5,
      SUPPORT: 6,
      REPORT: 7,
      TOOLS: 8,
      DATA: 9,
      HISTORY: 10,
      DATAHUB: 11,
    };
    return [...data].sort(
      (a, b) => (rank[a.permission] ?? 99) - (rank[b.permission] ?? 99),
    );
  }

  logout() {
    const token = localStorage.getItem("token") || '';
    // let baseToken = atob(token);
    localStorage.clear();
    sessionStorage.clear();
    this.authenticationService.logout(token).subscribe((res) => {});
    this.ngzone.run(() => {
      this.router.navigate(["/login"]);
    });
  }

  redirectTo() {
    this.subTabHeader = false;
    const defaultUrl = localStorage.getItem("defaultUrl");
    this.router.navigate([defaultUrl]);
  }

  menuClick() {
    this.menuClose.nativeElement.click();
  }

  dashboardClick(data: any) {
    this.menuClose.nativeElement.click();
    localStorage.setItem("currentDashboard", JSON.stringify(data));
    this.router.navigate(["/dashboard"], {
      queryParams: {
        id: data.dashboardId,
      },
    });
  }

  // getDashboards() {
  //   if (localStorage.getItem('dashboards')) {
  //     this.dashboards = JSON.parse(localStorage.getItem('dashboards') || '{}');
  //   } else {
  //     this.dashboardService.getDashboards().subscribe(res => {
  //       this.dashboards = res;
  //       localStorage.setItem('dashboards', JSON.stringify(res));
  //     }, error => {
  //       this.sharedService.getErrorMsg(error);
  //     });
  //   }
  // }

  tokenScenario(res: any) {
    this.authenticationService.getLoggedUser().subscribe(
      (reponseInFo) => {
        if (res.status === 404) {
          const errorCode = res.errorCode;
          const errorMessage = enMessage[errorCode];
          this.responseMessage = { success: false, message: errorMessage };
          this.sharedService.setResponseMessage(this.responseMessage);
        } else {
          this.authenticationService.setLoggedInUser(reponseInFo);
          this.permissionModules = reponseInFo.modules.map((data: any) => data.name);
          this.sharedService.setAccessRole(
            reponseInFo.modules,
            this.permissionModules,
          );
          this.sharedService.setDefaultUrl(this.permissionModules);
          if (this.permissionModules.includes("REPORT")) {
            localStorage.setItem(
              "lastReportUrl",
              "/reports/device/message-count",
            );
          }
          window.location.reload();
        }
      },
      (error) => {
        this.sharedService.getErrorMsg(error);
      },
    );
  }

  stopImpersonate() {
    if (this.isSupportViewMode()) {
      localStorage.removeItem("supportViewMode");
      this.router.navigate(["/support"]);
      this.getRoleAccessModule();
      return;
    }

    // Regular impersonation flow
    this.authenticationService.stopImpersonate().subscribe(
      (res) => {
        if (res.accessToken) {
          localStorage.clear();
          const base64Token = res.accessToken;
          this.authenticationService.setHeaders(base64Token);
          this._cookieService.delete("user");
          this.impersonate = false;

          this.tokenScenario(res);
          localStorage.setItem("impersonate", "false");
        } else if (res.status === 404) {
          const errorCode = res.errorCode;
          const errorMessage = enMessage[errorCode];
          this.responseMessage = { success: false, message: errorMessage };
          this.sharedService.setResponseMessage(this.responseMessage);
        }
      },
      (error) => {
        if (error.status === 404) {
          this.sharedService.getErrorMsg(error);
        } else {
          this.sharedService.getErrorMsg(error);
        }
      },
    );
  }

  getDefaultAdminUrl() {
    this.permissionModules = JSON.parse(
      localStorage.getItem("permissionModules") || '[]',
    );
    if (this.permissionModules.includes("ADMIN")) {
      if (this.permissionModules.includes("USER")) {
        this.defaultAdminUrl = "/admin/users";
        localStorage.setItem("defaultAdminUrl", this.defaultAdminUrl);
      } else if (this.permissionModules.includes("ROLE")) {
        this.defaultAdminUrl = "/admin/roles";
        localStorage.setItem("defaultAdminUrl", this.defaultAdminUrl);
      } else if (this.permissionModules.includes("PLACE")) {
        this.defaultAdminUrl = "/admin/place";
        localStorage.setItem("defaultAdminUrl", this.defaultAdminUrl);
      } else if (this.permissionModules.includes("ALERT")) {
        this.defaultAdminUrl = "/admin/alerts";
        localStorage.setItem("defaultAdminUrl", this.defaultAdminUrl);
      } else if (this.permissionModules.includes("HEADER")) {
        this.defaultAdminUrl = "/admin/headers";
        localStorage.setItem("defaultAdminUrl", this.defaultAdminUrl);
      } else if (this.permissionModules.includes("SETTING")) {
        this.defaultAdminUrl = "/admin/whitelabel";
        localStorage.setItem("defaultAdminUrl", this.defaultAdminUrl);
      } else if (this.permissionModules.includes("DEVELOPER")) {
        this.defaultAdminUrl = "/admin/developer";
        localStorage.setItem("defaultAdminUrl", this.defaultAdminUrl);
      } else if (this.permissionModules.includes("DESTINATION")) {
        this.defaultAdminUrl = "/admin/destination";
        localStorage.setItem("defaultAdminUrl", this.defaultAdminUrl);
      } else if (this.permissionModules.includes("RULE")) {
        this.defaultAdminUrl = "/admin/rules";
        localStorage.setItem("defaultAdminUrl", this.defaultAdminUrl);
      } else if (this.permissionModules.includes("AUDIT-TRIAL")) {
        this.defaultAdminUrl = "/admin/audit-trial";
        localStorage.setItem("defaultAdminUrl", this.defaultAdminUrl);
      } else if (this.permissionModules.includes("CACHE-ATTRIBUTES")) {
        this.defaultAdminUrl = "/admin/cache-attributes";
        localStorage.setItem("defaultAdminUrl", this.defaultAdminUrl);
      } else {
        this.defaultAdminUrl = "/admin/users";
        localStorage.setItem("defaultAdminUrl", this.defaultAdminUrl);
      }
    }
  }

  getUserNotification() {
    this.authenticationService.getUserNotification().subscribe(
      (res) => {
        this.notifications = res;
        if (res) {
          this.alertMessage = true;
        }
      },
      (error) => {
        this.alertMessage = false;
        this.sharedService.getErrorMsg(error);
      },
    );
  }

  getUnreadNotificationCount() {
    this.authenticationService.getUnreadNotificationCount().subscribe((res) => {
      this.unreadCount = res.count;
      localStorage.setItem("unreadNotification", JSON.stringify(res));
    });
  }

  readNotifications() {
    this.unreadCount = 0;
  }

  closeUserNotification(userNotificationId: string) {
    this.authenticationService
      .closeUserNotification(userNotificationId)
      .subscribe(
        (res) => {
          this.alertMessage = false;
        },
        (error) => {
          this.alertMessage = false;
          this.sharedService.getErrorMsg(error);
        },
      );
  }

  fetchImages() {
    const token = this.authenticationService.getHeaders();
    if (token) {
      const headers = new HttpHeaders({ Authorization: "Bearer " + token });
      // Fetch logo
      if (this.accountKey) {
        this.http
          .get(this.logoUrl, { headers, responseType: "blob" })
          .subscribe({
            next: (blob) => {
              const url = URL.createObjectURL(blob);
              this.logoSafeUrl = this.sanitizer.bypassSecurityTrustUrl(url);
            },
            error: () => {
              this.logoSafeUrl = this.logoUrl;
            },
          });
      }
      // Fetch profile picture
      if (this.currentUser.userId) {
        this.http
          .get(this.profilePicUrl, { headers, responseType: "blob" })
          .subscribe({
            next: (blob) => {
              const url = URL.createObjectURL(blob);
              this.profilePicSafeUrl =
                this.sanitizer.bypassSecurityTrustUrl(url);
            },
            error: () => {
              this.profilePicSafeUrl = "../../../../assets/img/user.png";
            },
          });
      }
    } else {
      this.logoSafeUrl = this.logoUrl;
      this.profilePicSafeUrl = this.profilePicUrl;
    }
  }
}
